import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDeleteTimelines,
	deleteTimeline,
	deleteTimelineFail,
	deleteTimelineSuccess,
	fetchTimelineListFail,
	fetchTimelineListSuccess,
	initTimelineList,
	refreshTimelineList,
	updateIncludePublic,
} from './timeline.actions';
import { TimelineMainSliceState } from './timeline.state';

export const timelineOriginalReducer = createReducer<TimelineMainSliceState>(
	new TimelineMainSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initTimelineList, refreshTimelineList, (state) => state.setLoading(true)),
	on(fetchTimelineListSuccess, (state, action) =>
		state.setLoading(false).setTimelineList(action.timelineList)
	),
	on(fetchTimelineListFail, (state) => state.setLoading(false)),
	on(updateIncludePublic, (state, action) =>
		state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
	),
	on(deleteTimeline, bulkDeleteTimelines, (state) => state.setLoading(true)),
	on(deleteTimelineSuccess, (state) => state.setDeleteSuccess(true)),
	on(deleteTimelineFail, (state) =>
		state.setDeleteSuccess(false).setLoading(false)
	)
);
